import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button } from "reactstrap";
import Header from "../../layout/Header/Header";

function BotonesReportesAdmin() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_reportes ? (
      <div className="container">
          <Row>
          <Col md={4} align="center">
                    {user.edoCtaClientes ?(
                      <Button href="/CalificadoraClientes" className="botonesMenu" color="success">
                        <i class="fas fa-exclamation-circle fa-7x"></i>
                        <br />
                        <br />
                        Calificadora Clientes
                      </Button>
                    ): <Button disabled className="botonesMenu" color="success">
                    <i class="fas fa-exclamation-circle fa-7x"></i>
                    <br />
                    <br />
                    Calificadora Clientes
                  </Button> }
                    </Col>

                    <Col md={4} align="center">
          {user.abonos ?(
            <Button href="/ListadoAbonos" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Abonos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Abonos
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.abonos ?(
            <Button href="/AntiguedadSaldosVencido" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Antiguedad <br /> Saldos Vencido
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Antiguedad <br /> Saldos Vencido
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.abonos ?(
            <Button href="/CobranzaVendedor" className="botonesMenu" color="success">
              <i class="fas fa-hand-holding-usd fa-7x"></i>
              <br />
              <br />
              Cobranza <br /> por Vendedor
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-hand-holding-usd fa-7x"></i>
          <br />
          <br />
          Cobranza <br /> por Vendedor
        </Button> }
          </Col>

          </Row>
            <br />
            <Row>

          <Col md={4} align="center">
          {user.abonos ?(
            <Button href="/AntiguedadSaldosPorCobrar" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Antiguedad <br /> Saldos Pend
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Antiguedad <br /> Saldos Pend
        </Button> }
          </Col>
            </Row>
      </div>
      ) : undefined}
    </>
  );
}

export default BotonesReportesAdmin;
